var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquares2X2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40039 8.7998C6.39419 8.80002 7.19998 9.60581 7.2002 10.5996V12.5996C7.2002 13.5936 6.39432 14.4002 5.40039 14.4004H3.40039C2.40628 14.4004 1.59961 13.5937 1.59961 12.5996V10.5996C1.59982 9.60568 2.40641 8.7998 3.40039 8.7998H5.40039ZM12.5996 8.7998C13.5936 8.7998 14.4002 9.60568 14.4004 10.5996V12.5996C14.4004 13.5937 13.5937 14.4004 12.5996 14.4004H10.5996C9.60568 14.4002 8.7998 13.5936 8.7998 12.5996V10.5996C8.80002 9.60581 9.60581 8.80002 10.5996 8.7998H12.5996ZM5.40039 1.59961C6.39432 1.59982 7.2002 2.40641 7.2002 3.40039V5.40039C7.19998 6.39419 6.39419 7.19998 5.40039 7.2002H3.40039C2.40641 7.2002 1.59982 6.39432 1.59961 5.40039V3.40039C1.59961 2.40628 2.40628 1.59961 3.40039 1.59961H5.40039ZM12.5996 1.59961C13.5937 1.59961 14.4004 2.40628 14.4004 3.40039V5.40039C14.4002 6.39432 13.5936 7.2002 12.5996 7.2002H10.5996C9.60581 7.19998 8.80002 6.39419 8.7998 5.40039V3.40039C8.7998 2.40641 9.60568 1.59982 10.5996 1.59961H12.5996Z",
    fill: "url(#paint0_linear_4_1067)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_1067",
    x1: -3.03427,
    y1: -3.81871,
    x2: 16.9984,
    y2: 10.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares2X2);
export default __webpack_public_path__ + "static/media/Squares2x2.f5a430c8839c44908d9ebd04454ee86d.svg";
export { ForwardRef as ReactComponent };